const getTreeviewSubSectionItems = (item, cond) => {
    const items = [];

    getTreeviewSubSectionItemsRec(item, cond, items);

    return items;
}

const getTreeviewSubSectionItemsRec = (item, cond, items = []) => {
    for(const menuItem of item.menuItems) {
        menuItem._inTreeview = true;

        if (typeof cond == 'function' && !cond.call(null, menuItem)) continue;

        items.push(menuItem);
    }

    item.items.forEach((subItem) => getTreeviewSubSectionItemsRec(subItem, cond, items));
}

const getTreeviewSubSectionItemById = (item, uuid) => {
    return item.menuItems.find((menuItem) => menuItem._uuid == uuid)
        || item.items.map((subItem) => getTreeviewSubSectionItemById(subItem, uuid)).find(subItem => subItem);
}

const getTreeviewSubSectionItemsWithPath = (item, path) => {

    if (item.menuItems.length) {
        return [
            {
                caption: getItemPath(item, path),
                items: item.menuItems
            },
            ...item.items.reduce((items, subItem) => [...items, ...getTreeviewSubSectionItemsWithPath(subItem, getItemPath(item, path))], [])
        ]
    }

    return item.items.reduce((items, subItem) => [...items, ...getTreeviewSubSectionItemsWithPath(subItem, getItemPath(item, path))], []);
}

const getItemPath = (item, path) => path ? `${path} \\ ${item.caption}` : item.caption;

const preventCloseOnClickInsideDropdown = (dropdownElement) => {
    dropdownElement.on('hide.bs.dropdown', (e) => {
        if (!e.clickEvent) return true;

        const dropdownContainsClickedEl = Boolean($(e.currentTarget).has(e.clickEvent.target).length);

        return !dropdownContainsClickedEl;
    });
}

const getQuickAccessItems = (items, condFn, sortFn) => {
    const menuItems = items.reduce((quickAcessItems, item) => {
        if(!item.items) {
            if (condFn(item)) {
                quickAcessItems.push(item)
            };
            
            return quickAcessItems;
        }
        if (item.withTreeview) {
            return [...quickAcessItems, ...getTreeviewSubSectionItems(item.items, condFn)]
        }

        return [...quickAcessItems, ...getQuickAccessItems(item.items, condFn)];
    }, []);

    return sortFn ? menuItems.sort(sortFn) : menuItems;
}

const getItemById = (items, uuid) => {
    const findItem = (items, uuid) => {
        if (items._uuid == uuid) return items;
        if (items.withTreeview) return getTreeviewSubSectionItemById(items.items, uuid);
        if (items.items) {
            let itemToReturn = null;
            const itemss = items.items.peek ? items.items.peek() : items.items;
    
            for (const item of itemss) {
                const itemFound = findItem(item, uuid);
    
                if (itemFound) {
                    itemToReturn = itemFound;
                    break;
                }
            }
    
            return itemToReturn;
        }
    };
    
    let item = null;

    items.find((section) => item = findItem(section, uuid));
    
    return item; 
}

const getScrollSizeForPopper = (options) => {
    const additionalSize = options.sizes || [];
    const sizes = {
        'max-height': `calc(100vh - ${options.offsetTop} - ${options.spacingBottom} - ${options.marginBottom} ${additionalSize.length ? '- ' : ''}${additionalSize.join(' - ')})`,
    };

    if (options.useMinHeight) {
        sizes['min-height'] = `min(150px, ${sizes['max-height']})`;
    }

    return sizes;
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = {
        getTreeviewSubSectionItems,
        getTreeviewSubSectionItemById,
        getTreeviewSubSectionItemsWithPath,
        preventCloseOnClickInsideDropdown,
        getQuickAccessItems,
        getItemById,
        getScrollSizeForPopper
    };
}